// extracted by mini-css-extract-plugin
export default {"dragOverlay":"dragOverlay_mfFWT","dragContent":"dragContent_edvVS","dragIcon":"dragIcon_Sjm0D","dragTitle":"dragTitle_XmFRe","dragDesc":"dragDesc_pMoLd"};